module.exports = __webpack_public_path__ + "img/tarixiy2.4880b6fc.jpg";